import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Hold } from '../builders/holds_builder';
import { HoldsService } from '../services/holds_service';

angular
  .module('capability-ng-holds')
  .factory(
    'loadHoldsCommand',
    function loadHoldsCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngHoldDatastore: IDatasource<Hold>
    ) {
      return defineCommand('loadHoldsCommand', function loadHoldsCommand(deferred: any, refresh: boolean = true) {
        const refreshUrl = refresh ? '/refresh' : '';
        $http
          .get(`holds/holds${refreshUrl}`)
          .then(({ data }: any) => {
            ngHoldDatastore.clear();
            ngHoldDatastore.write(data);
            ORM.run();
            deferred.resolve(ngHoldDatastore);
          })
          .catch((data: any) => {
            deferred.reject(data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/commands/load_holds_command.ts